/**
 * Toasts de notificación del POS.
 */

export function attachNotificationsGlobals(win, $) {
	win.mostrarNotificacion = function mostrarNotificacion(mensaje, tipo) {
		const notificacion = $(`<div class="notification ${tipo}">${mensaje}</div>`);
		$('body').append(notificacion);
		win.setTimeout(() => {
			notificacion.remove();
		}, 3000);
	};
}
